/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class FacebookIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      fill="currentcolor"
      width="24px"
      height="24px"
      viewBox="0 0 24 24" {...this.props} >
      <title>facebook</title>
      <desc>Created with Sketch.</desc>
      <defs/>
      <g
        id="facebook"
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
      >
        <path
          d="M9.60639618,13.0109114 L6,13.0109114 L6,8.98055699 L9.60639618,8.98055699 C9.59008595,7.81204717 9.59008595,7.02956131 9.60639618,6.63309942 C9.64254452,5.75442114 9.67976394,4.97469998 9.86800032,4.31295034 C10.0592294,3.64067965 10.4040595,3.08981427 10.7712939,2.635901 C11.3458981,1.92567228 12.3200939,1.34058125 13.7007882,1.1003684 C14.4699842,0.966543867 15.9063882,0.931744596 18.0100002,0.995970582 L18.0100002,5.00807478 C16.6962309,5.00807478 15.7997021,5.00807478 15.3204136,5.00807478 C14.4264903,5.00807478 14.0081819,5.86670866 14.0081819,6.55176004 C14.0081819,7.00846097 14.0081819,7.81805995 14.0081819,8.98055699 L18.0100002,8.98055699 L17.4479483,13.0109114 L14.0081819,13.0109114 L14.0081819,23 L9.58129406,23 L9.60639618,13.0109114 Z"
          id="Rectangle-88"
        />
      </g>
    </svg>;
  }
}

const Icon = pure(FacebookIcon);
Icon.displayName = 'FacebookIcon';
export default Icon;
